export default __webpack_public_path__ + "static/media/photo4.4b352b52.jpg";